import { Pipe, PipeTransform, inject } from '@angular/core';
import { DeviceRegistrationStatus } from '../../../shared/models/generated/ziroModels';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'phoneStatusFilter',
  standalone: false,
})
export class PhoneStatusFilter implements PipeTransform {
  private translateService = inject(TranslateService);

  transform(value: string): string {
    switch (value) {
      case DeviceRegistrationStatus.UNREGISTERED: {
        return this.translateService.instant('tkey;userdetail.desk_phone.status.unregistered.label');
      }
      case DeviceRegistrationStatus.NOT_FOUND: {
        return this.translateService.instant('tkey;userdetail.desk_phone.status.not_found.label');
      }
      default: {
        return '';
      }
    }
  }
}
